import moment from 'moment-timezone'

moment.tz.setDefault('Asia/Tokyo')

export const ERROR_MESSAGE = {
  DUPLICATE_FILENAME:
    '同じ名前のファイルが既に選択されています。\n一度ファイルを削除してから、再度選択してください。',
  CONTAINS_DIRECTORY:
    'ディレクトリが含まれていたため除外しました。\nアップロードできるのはファイルのみです。'
}

/**
 * ランダム文字列を生成する
 * @param {int} length 文字列長
 * @param {boolean} upperLetter 大文字を含めるか
 * @param {boolean} lowerLetter 小文字を含めるか
 * @param {boolean} number 数字を含めるか
 * @param {boolean} symbol 記号を含めるか
 * @returns {string} ランダムな文字列
 */
export function getRandomStr (
  length = 8,
  upperLetter = true,
  lowerLetter = true,
  number = true,
  symbol = true
) {
  const source = []
  if (upperLetter) {
    source.push('ABCDEFGHIJKLMNOPQRSTUVWXYZ')
  }
  if (lowerLetter) {
    source.push('abcdefghijklmnopqrstuvwxyz')
  }
  if (number) {
    source.push('0123456789')
  }
  if (symbol) {
    source.push('!#$%&=~/*-+')
  }

  let offset = source.length - 1
  let randomConfig = [] // ランダム設定配列
  let sum = 0
  let result = ''

  // どのSOURCEを何文字含むかをランダムで設定
  for (let i = 0; i <= offset; i++) {
    let includeNum =
      i === offset
        ? length - sum
        : 1 + Math.floor(Math.random() * (length - offset - sum - i + 2))

    randomConfig.push({
      src: source[i], // 元になるSOURCE
      includeNum: includeNum, // 含む回数
      count: 0 // 含まれた回数
    })
    sum += includeNum
  }

  // 指定した長さのランダムな文字列を生成
  for (let i = 0; i < length; i++) {
    let index = 1 + Math.floor(Math.random() * randomConfig.length - 1)
    let randomSource = randomConfig[index]

    // ランダムなSOURCEから文字を選んで結合
    result +=
      randomSource.src[Math.floor(Math.random() * randomSource.src.length)]

    randomSource.count++

    // countとincludeNumが一致したらrandomConfig配列から削除
    if (randomSource.count === randomSource.includeNum) {
      randomConfig.splice(index, 1)
    }
  }

  return result
}

/**
 * 名前で比較する
 * @param {object} a 比較対象
 * @param {object} b 比較対象
 * @returns {int} aがbより大きければ-1, 同じなら0, 小さければ1
 */
export function compareName (a, b) {
  const aName = a.name
  const bName = b.name
  if (aName === bName) {
    return 0
  }
  return aName > bName ? -1 : 1
}

/**
 * アップロード時刻で比較する
 * @param {object} a 比較対象
 * @param {object} b 比較対象
 * @returns {int} aがbより新しければ-1, 同じなら0, 古ければ1
 */
export function compareDate (a, b) {
  const aDate = moment(a.uploaded_date)
  const bDate = moment(b.uploaded_date)
  if (aDate.isSame(bDate)) {
    return 0
  }
  return aDate.isAfter(bDate) ? -1 : 1
}

export const ERROR_MESSAGES = {
  UNAUTHORIZED: 'ログイン情報が誤っています。',
  FORBIDDEN:
    'ご利用可能な期限が過ぎています。\n再度ファイルの処理が必要な場合、ファイル送付者に御連絡ください。',
  CONFLICT:
    '処理済みのため、ご利用可能な状態ではありません。\n再度ファイルの処理が必要な場合、ファイル送付者に御連絡ください。',
  UNKNOWN_AUTHORIZATION_ERROR: '認証に失敗しました。'
}

/**
 * ステータスコードをエラーメッセージに変換する
 * @param {number} statusCode
 * @returns {string}
 */
export function toErrorMessage (statusCode) {
  const UNAUTHORIZED = 401
  const FORBIDDEN = 403
  const CONFLICT = 409
  switch (statusCode) {
    case UNAUTHORIZED:
      return ERROR_MESSAGES['UNAUTHORIZED']
    case FORBIDDEN:
      return ERROR_MESSAGES['FORBIDDEN']
    case CONFLICT:
      return ERROR_MESSAGES['CONFLICT']
    default:
      return ERROR_MESSAGES['UNKNOWN_AUTHORIZATION_ERROR']
  }
}
